import React from 'react'

export default class Component extends React.Component {
  render = () => {
    return(
      <div className='container'>
        <h2 className='headline'>会社概要</h2>
        <table className='table'>
          <tbody>
            <tr>
              <th>会社名</th>
              <td>株式会社circrew(サークルー)</td>
            </tr>
            <tr>
              <th>英文社名</th>
              <td>circrew Inc.</td>
            </tr>
            <tr>
              <th>代表</th>
              <td>遠藤ちひろ</td>
            </tr>
            <tr>
              <th>設立年月日</th>
              <td>2016年12月08日</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>東京都渋谷区東1-2-20 渋谷ファーストタワー</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/StaticPages/Company/Company.jsx